class detectDeviceDirective {
	constructor($uris) {
		"ngInject";

		this.$uris = $uris;

		this.restrict = "A";
	}

	link(scope, element) {

		angular.element(element).addClass(`${this.$uris.APP}-app`);

	}

	static create() {
		return new detectDeviceDirective(...arguments);
	}
}

detectDeviceDirective.create.$inject = ["$uris"];

export {detectDeviceDirective};


// WEBPACK FOOTER //
// ./sources/directives/detect-device.directive.js